<template>
  <div>
    <div class="container-fluid">
      <div class="row mb-3">
        <div class="col-md-12">
          <vx-card>
            <div class="row">
              <div class="col-md-2">
                <small class="date-label">{{$t('selectUser')}}</small>
                <UserSelect @receiveData="veri"></UserSelect>
              </div>
              <div class="col-md-2">
                <small class="date-label">{{$t('selectLog')}}</small>
                <v-select
                  :placeholder="$t('selectLog')"
                  label="name"
                  :closeOnSelect="true"
                  v-model="logType"
                  :options="logTypeOptions"
                />
              </div>
              <div class="col-md-2">
                <small class="date-label">{{$t('startDate')}}</small>
                <datepicker
                  :language="$vs.rtl ? langEn : langTr  "
                  name="start-date"
                  v-model="FromCreateDate"
                  :disabled="disabledFrom"
                  :placeholder="$t('selectDate')"
                ></datepicker>
              </div>
              <div class="col-md-2">
                <small class="date-label">{{$t('finishDate')}}</small>
                <datepicker
                  :language="$vs.rtl ? langEn : langTr"
                  name="start-date"
                  v-model="ToCreateDate"
                  :disabled="disabledFrom"
                  :placeholder="$t('selectDate')"
                ></datepicker>
              </div>
              <div class="col-md-2">
                <vs-button
                  class="mt-6"
                  color="dark"
                  type="border"
                  icon="search"
                  @click="getByFilter"
                >{{$t('filter')}}</vs-button>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <vx-card>
            <div class="row">
              <div class="col-md-12 mt-4">
                <vs-input
                  size="small"
                  style="float:right;height:15px"
                  @input="isTyping = true"
                  :label-placeholder="$t('search')"
                  v-model="SearchText"
                />
              </div>
              <vs-table :data="$store.state.logs" class="w-full" maxHeight="1500px" max-items="20">
                <template slot="header">
                  <h3>{{ $t('logs') }}</h3>
                </template>
                <template slot="thead">
                  <vs-th class="colors">{{$t("controller")}}</vs-th>
                  <vs-th class="colors">{{$t("logType")}}</vs-th>
                  <vs-th class="colors">{{$t("userName")}}</vs-th>
                  <vs-th class="colors" sort-key="createDate">{{$t("addedDate")}}</vs-th>
                  <vs-th class="colors">{{$t("methodName")}}</vs-th>
                  <vs-th class="colors">{{$t("className")}}</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr class="tr" :key="indextr" v-for="(item, indextr) in data">
                    <vs-td :data="item.detail">
                      <vs-button
                        color="warning"
                        data-toggle="modal"
                        data-target="#modal"
                        type="border"
                        @click="setData(item.detail)"
                      >{{$t('detail')}}</vs-button>
                    </vs-td>
                    <vs-td :data="item.audit">{{ item.audit }}</vs-td>
                    <vs-td :data="item.userName">{{ item.userName }}</vs-td>
                    <vs-td :data="item.createDate">{{ item.createDate }}</vs-td>
                    <vs-td :data="item.methodName">{{ item.methodName }}</vs-td>
                    <vs-td :data="item.className">{{ item.className }}</vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <div class="col-md-12 mt-5">
                <vs-pagination
                  v-show="$store.state.logs.length != 0"
                  :total="totalPage"
                  :max="9"
                  v-model="currentPage"
                  @change="selectPage"
                ></vs-pagination>
              </div>
            </div>
          </vx-card>
          <div
            class="modal fade"
            id="modal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <json-tree :raw="jsonSource"></json-tree>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import { tr, en } from "vuejs-datepicker/src/locale";
import JsonTree from "vue-json-tree";
import UserSelect from "../../components/UserSelect";
import http from "../../../http/http-helper";
import notify from "../../../shared/toast";

export default {
  components: {
    JsonTree,
    Datepicker,
    UserSelect,
  },
  data() {
    return {
      currentPage: 1,
      totalPage: 0,
      SearchText: "",
      FromCreateDate: moment().subtract(1, "days").format("YYYY/MM/DD"),
      ToCreateDate: moment().format("YYYY/MM/DD"),
      startDate: "",
      endDate: "",
      AuditType: "",
      isTyping: false,
      logs: [],
      jsonSource: "",
      langTr: tr,
      langEn: en,
      logType: "",
      selectedName: "",
      disabledFrom: false,
      logTypeOptions: ["ERROR", "INFO", "WARNING", "DEBUG"],
    };
  },
  watch: {
    SearchText: _.debounce(function () {
      this.isTyping = false;
    }, 500),
    isTyping: function (value) {
      if (!value) {
        this.search(this.SearchText);
      }
    },
  },
  computed: {
    disabledDatesTo() {
      return { to: new Date(this.startDate) };
    },
    disabledDatesFrom() {
      return { from: new Date(this.endDate) };
    },
  },
  methods: {
    veri(value) {
      return (this.selectedName = value);
    },
    selectPage(id) {
      if (id == "") id = 1;
      this.currentPage = id;
      if (this.selectedName != "")
        var obj = {
          RequestPage: this.currentPage,
          AuditType: this.logType,
          UserId: this.selectedName,
          FromCreateDate: this.FromCreateDate,
          ToCreateDate: this.ToCreateDate,
        };
      if (this.selectedName == "")
        var obj = {
          RequestPage: this.currentPage,
          AuditType: this.logType,
          FromCreateDate: this.FromCreateDate,
          ToCreateDate: this.ToCreateDate,
        };
      let path = "/logs/getlistbypaging";
      http.post(path, obj).then((response) => {
        this.currentPage = response.currentPage;
        this.totalPage = response.totalPage;
        this.logs = response.data;
        this.$store.state.logs = this.logs;
      });
    },
    search(SearchText) {
      let path = "/logs/getlistbypaging";
      http
        .post(path, {
          RequestPage: 1,
          SearchText: SearchText,
          FromCreateDate: this.FromCreateDate,
          ToCreateDate: this.ToCreateDate,
        })
        .then((response) => {
          if (response.data.lenght == 0) {
            return notify.warning(this.$t("nomatch"));
          }
          this.currentPage = response.currentPage;
          this.totalPage = response.totalPage;
          this.logs = response.data;
          this.$store.state.logs = this.logs;
        });
    },
    getByFilter() {
      if (this.selectedName != "")
        var obj = {
          RequestPage: this.currentPage,
          AuditType: this.logType,
          UserId: this.selectedName,
          FromCreateDate: this.FromCreateDate,
          ToCreateDate: this.ToCreateDate,
        };
      if (this.selectedName == "")
        var obj = {
          RequestPage: this.currentPage,
          AuditType: this.logType,
          FromCreateDate: this.FromCreateDate,
          ToCreateDate: this.ToCreateDate,
        };

      let path = "/logs/getlistbypaging";
      http.post(path, obj).then((response) => {
        this.currentPage = response.currentPage;
        this.totalPage = response.totalPage;
        this.logs = response.data;
        this.$store.state.logs = this.logs;
      });
    },
    setData(detail) {
      this.jsonSource = detail;
    },
  },
};
</script>

<style scoped>
.colors {
  background-color: rgb(218, 216, 216) !important;
}

.width {
  width: 130px !important;
}
.ust {
  z-index: 3000 !important;
}
</style>